export default "__VITE_ASSET__BwID_uKe__"